import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, encodedStringParser, numberParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
function jacksToChipsOptionTypeParser(str) {
    return str === 'jacks' ? 'jacks' : 'purchase';
}
const jacksToChipsOptionPartDefinitions = [
    { name: 'jacksToChipsOptionId', parser: numberParser },
    { name: 'deprecatedJacksToChipsOptionType', parser: jacksToChipsOptionTypeParser },
    { name: 'numChips', parser: numberParser },
    { name: 'numJacks', parser: numberParser },
    { name: 'priceInDollars', parser: numberParser },
    { name: 'deprecatedSummaryHtml', parser: encodedStringParser }
];
function jacksToChipsOptionParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, jacksToChipsOptionPartDefinitions);
}
export const SHOW_JACKS_TO_CHIPS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'jacksToChipsOptions', parser: createArrayWithBracesParser(jacksToChipsOptionParser) }]
};
